import { getByPath, uniqid } from "../../tools/utils";
import type { SelectProps } from "../../types/Interface";
import { useTrads } from "../../contexts/trads/useTrads";
import type { FieldError } from "react-hook-form";
interface PlusStatut {
    statut:"00_draft" | "01_published" | "02_refused"
};
type StatutSelectProps = SelectProps & PlusStatut

export function CommonStatutSelectorBootstrap({name, label, registerOutput, errors, statut}:StatutSelectProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name) as FieldError[];
    const {translate}=useTrads()
    return (
        <>
        <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
                <select className={"form-select "+ (errors[name]? " is-invalid":'')} id={id}
                 defaultValue={statut}
                 {...registerOutput} 
                >
                    <option value="">-----</option>

                    <option value="00_draft" >{translate('statut_00_draft')}</option>
                    <option value="01_published" >{translate('statut_01_published')}</option>
                    <option value="02_refused"  >{translate('statut_02_refused')}</option>                    
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
                
        </div>
        {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> 
                <p key={error.message} role="alert">{translate(error.message)}</p>)
            }</div>}
        </>
    );
}